/**
 * Type Guards
 *
 * Small, dependency-free runtime guards shared across pages, components and the
 * service layer. Keep them narrow and predictable: they feed TypeScript's
 * narrowing, so a change here ripples through every caller's inferred types.
 */

/**
 * Narrow an unknown value to a plain keyed object.
 *
 * Arrays are rejected on purpose: callers use this before reading named
 * properties off parsed JSON, and an array would satisfy `typeof === 'object'`
 * while having none of them.
 *
 * @example
 * isRecord({ a: 1 }) // true
 * isRecord([1, 2])   // false
 * isRecord(null)     // false
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
